import { Link } from 'react-router-dom';
import { locationDetailPath } from '@/lib/entityPaths';
import { entityLinkClassName } from '@/lib/entityLink';
import { cn } from '@/lib/utils';

export interface LocationLinkProps {
  locationType: string;
  locationId: string;
  name: string;
  className?: string;
}

export function LocationLink({ locationType, locationId, name, className }: LocationLinkProps) {
  const label = name.trim() || '—';
  const href = locationDetailPath(locationType, locationId);

  if (!href) {
    return <span className={className}>{label}</span>;
  }

  return (
    <Link to={href} className={cn(entityLinkClassName, className)}>
      {label}
    </Link>
  );
}
